/**
 * Localization messages for useActivationBanner hook
 */
const invertedMessages = {
  'Your {ruleName} Rule has been activated!':
    'ruleRecs.banner.ruleActivationSuccess',
  "Your rule {ruleName} couldn't be activated.":
    'ruleRecs.banner.ruleActivationError',
} as const;

export default invertedMessages;
